import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { UserData } from '../model/UserData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.css']
})
export class AccountDetailsComponent implements OnInit {
  details = new UserData();
  name;
  email;
  age;
  gender = "female";
  race;
  height;
  riskScore;
  weight;

  constructor(
    private _bkoffService: BackOffServiceService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {

    this._bkoffService.getAccountDetails().then((res) => {
      this.name = res.FullName;
      this.email = res.Email;
      this.age = res.age;
      this.height = res.height;
      this.riskScore = res.riskScore;

      if (res.gender == 1) {
        this.gender = "male";
      }

      switch (res.race) {
        case 1:
          this.race = "African American";
          break;
        case 2:
          this.race = "Hispanic";
          break;
        case 3:
          this.race = "Native American";
          break;
        case 4:
          this.race = "Asian";
          break;
        case 5:
          this.race = "Caucasian";
          break;
        case 6:
          this.race = "Pacific Islander";
          break;
        case 7:
          this.race = "Two or more races";
          break;
        default:
          this.race = "N/A";
          break;
      }
    })

    this._bkoffService.getCurrentWeight().then((res) => {
      this.weight = res;
    })

  }

}
